import React from "react";
import { ConsentSettingRow } from "../../../consentBanner/ConsentSettingRow";
import { ConsentOptionCards } from "../../../consentBanner/ConsentOptionCards";
import { BannerThumbnail } from "../../../consentBanner/ConsentThumbnails";

export const ConsentBannerBackgroundColorRow = () => {
  return (
    <ConsentSettingRow
      title="Background"
      helpText="Choose between a translucent light or dark background color for your consent pop-up to match the look of your website."
    >
      <ConsentOptionCards
        field="bannerBackgroundColor"
        ariaLabel="Background"
        options={[
          {
            value: "#eeeeee" /* This color should be kept in sync with PrivacyCenter.kt */,
            label: "Light",
            preview: <BannerThumbnail bannerColor="light" />,
          },
          {
            value: "#222222",
            label: "Dark",
            preview: <BannerThumbnail bannerColor="dark" />,
          },
        ]}
      />
    </ConsentSettingRow>
  );
};
